import type { StaticPageDefinition } from './static-pages';
import { STATIC_PAGES } from './static-pages';
import {
  buildStaticPageSeo,
  resolveSiteOrigin,
  type SeoArtifact,
} from '../content/seo';

type HeadMeta = Record<string, string>;

export type RouteHeadDescriptor = {
  meta: HeadMeta[];
  links?: HeadMeta[];
};

export function seoArtifactToHead(artifact: SeoArtifact): RouteHeadDescriptor {
  const meta: HeadMeta[] = [
    { title: artifact.title },
    { name: 'description', content: artifact.description },
    { name: 'robots', content: artifact.robots },
    { property: 'og:type', content: artifact.openGraph.type },
    { property: 'og:title', content: artifact.openGraph.title },
    { property: 'og:description', content: artifact.openGraph.description },
    { property: 'og:url', content: artifact.openGraph.url },
    { name: 'twitter:card', content: artifact.twitter.card },
    { name: 'twitter:title', content: artifact.twitter.title },
    { name: 'twitter:description', content: artifact.twitter.description },
  ];

  if (artifact.openGraph.image) {
    meta.push({ property: 'og:image', content: artifact.openGraph.image });
  }

  if (artifact.twitter.image) {
    meta.push({ name: 'twitter:image', content: artifact.twitter.image });
  }

  return {
    meta,
    links: [{ rel: 'canonical', href: artifact.canonicalUrl }],
  };
}

export function staticPageHead(
  path: StaticPageDefinition['path']
): RouteHeadDescriptor {
  const page = STATIC_PAGES.find((entry) => entry.path === path);
  if (!page) {
    throw new Error(`Unknown static page path: ${path}`);
  }

  return seoArtifactToHead(buildStaticPageSeo(page, resolveSiteOrigin()));
}
